<template>
	<div class="edit-links-wrap" :class="{'mobile': mobile}">
		<div class="navbar" :class="{'mobile': mobile}">
			<span>{{ $t('profile.editLinksInfo') }}</span>
			<span @click="closeEdit" class="material-icons">clear</span>
		</div>
		<div class="content" :class="{'mobile': mobile}">
			<div class="social-links">
				<img :src="$images.facebookB" draggable="false" />
				<input type="text" v-model="facebook" :placeholder="$t('profile.pasteFbLink')" />
			</div>
			<div class="social-links">
				<img :src="$images.twitterB" draggable="false" />
				<input type="text" v-model="twitter" :placeholder="$t('profile.pasteTwitterLink')" />
			</div>
			<div class="social-links">
				<img :src="$images.linkedinB" draggable="false" />
				<input type="text" v-model="linkedin" :placeholder="$t('profile.pasteLinkedInLink')" />
			</div>
			<div class="details">
				<div class="title">
					<span>{{ $t('helpPage.submitForm.phone') }}</span>
				</div>
				<input type="text" v-model="phone" :placeholder="$t('profile.pastePhone')" />
			</div>
			<div class="details">
				<div class="title title-2">
					<span>{{ $t('profile.scheduleMeeting') }}</span>
					<span @click="goToDetails">{{ $t('profile.details') }}</span>
				</div>
				<input type="text" v-model="calendly" :placeholder="$t('profile.pasteCalendly')" />
			</div>
			<div class="details">
				<div class="title">
					<span>{{ $t('profile.websiteLink') }}</span>
				</div>
				<input type="text" v-model="website" :placeholder="$t('profile.pasteWebsite')" />
			</div>
			<!-- <div class="allow-checkbox">
				<input id="ch1" type="checkbox" :value="true" v-model="phVisible" />
				<label for="ch1">I allow that other participants see my phone number</label>
			</div>
			<div class="allow-checkbox">
				<input id="ch2" type="checkbox" :value="true" v-model="emVisible" />
				<label for="ch2">I allow that other participants see my email address</label>
			</div> -->
		</div>
		<div class="toolbar" :class="{'mobile': mobile}">
			<button @click="closeEdit">{{ $t('button.cancel') }}</button>
			<button @click="upload">
				{{ $t('profile.saveChanges') }}
				<span>+</span>
			</button>
		</div>
	</div>
</template>

<script>
import api from "../../api";
import isMobileMixin from "../../mixins/isMobileMixin";
export default {
	data() {
		return {
			detailsLink: "https://calendly.com/login",
			facebook: "",
			twitter: "",
			linkedin: "",
			phone: "",
			calendly: "",
			website: "",
			phVisible: false,
			emVisible: false
		};
	},
	props: {
		links: Object
	},
	computed: {
		mobile() {
			return this.isMobile;
		}
	},
	mixins: [isMobileMixin],
	mounted() {
		this.init();
	},
	methods: {
		init() {
			if (!this.links) return;
			this.facebook = this.links.facebook;
			this.twitter = this.links.twitter;
			this.linkedin = this.links.linkedin;
			this.phone = this.links.phone;
			this.calendly = this.links.calendly;
			this.website = this.links.website;
		},
		goToDetails() {
			window.open(this.detailsLink);
		},
		closeEdit() {
			this.$emit("close");
		},
		async upload() {
			let socials = {
				facebook: this.facebook,
				twitter: this.twitter,
				linkedin: this.linkedin,
				phone: this.phone,
				calendly: this.calendly,
				website: this.website
			};
			let obj = {
				data: {
					basic: {
						usr_socnet: socials
					}
				}
			};
			try {
				this.startLoading();
				await api.updateProfile(obj);
				this.closeEdit();
			} catch (error) {
				this.handleError(error);
				this.stopLoading();
				return;
			}
			this.stopLoading();
			let infoObj = {
				message: this.$t('profile.linkSavedSuccesMessage')
			}
			this.EventBus.$emit('info', infoObj);
		}
	}
};
</script>

<style lang="scss" scoped>
@mixin flex-end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
@mixin flex-evenly {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
}
@mixin flex-between {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
@mixin flex-start {
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
}
@mixin flex-center {
	display: flex;
	justify-content: center;
	align-items: center;
}
.edit-links-wrap {
	padding: 20px;
	z-index: 51;
	position: absolute;
	top: 50%;
	left: 100px;
	width: 40vw;
	height: 80vh;
	min-width: 300px;
	transform: translate(0, -50%);
	background: white;
	box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.15);
	border-radius: 10px;
	&.mobile {
		width: 80%;
		height: 90%;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
}
.navbar {
	@include flex-between();
	position: relative;
	width: 100%;
	height: 40px;
	span:first-child {
		font-size: 25px;
		font-weight: 700;
		color: #6f6f6f;
	}
	span:nth-child(2) {
		cursor: pointer;
	}
}
.navbar::after {
	position: absolute;
	content: "";
	width: 100%;
	height: 1px;
	bottom: 0px;
	left: 0;
	background: #888c8e;
}
input {
	border: none;
	background: white;
}
.content {
	box-sizing: border-box;
	padding: 20px;
	background: white;
	width: 100%;
	height: calc(100% - 100px);
	overflow: auto;
	.social-links {
		@include flex-center();
		margin: 20px 0;
		img {
			margin-right: 20px;
		}
		input:focus {
			outline: none;
		}
		input::placeholder {
			font-style: italic;
		}
	}
	.details {
		margin: 20px 0;
		.title {
			@include flex-start();
			margin-bottom: 5px;
			span {
				color: #888c8e;
			}
		}
		.title.title-2 {
			@include flex-between();
			span:last-child {
				color: #2e66ff;
				cursor: pointer;
			}
		}
		input:focus {
			outline: none;
		}
		input::placeholder {
			font-style: italic;
		}
	}
	.allow-checkbox {
		margin: 20px 0;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		input {
			border: none;
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
			width: 20px;
			height: 20px;
			margin-right: 20px;
		}
		label {
			user-select: none;
		}
	}
}

.toolbar {
	button:focus {
		outline: none;
	}
	@include flex-end();
	padding: 0 8%;
	position: absolute;
	width: calc(100% - 40px);
	height: 80px;
	bottom: 0;
	box-sizing: border-box;
	&.mobile {
		padding: 0;
	}
	button:first-child {
		opacity: 0.7;
		margin-right: 10px;
	}
	button {
		cursor: pointer;
		font-weight: 600;
		font-size: 15px;
		color: white;
		@include flex-evenly();
		flex-shrink: 1;
		flex-basis: 150px;
		height: 40px;
		border: none;
		background: #888c8e;
		border-radius: 10px;
		span {
			font-size: 30px;
			font-weight: 500;
		}
	}
}
</style>